import React, { FC } from 'react';
import { LocationType } from '../../@posturinn/client-react';
import Location from '../postOfficeTools/location';

interface Props {
	display: any;
}

const NearestPostboxOrPostoffice: FC<Props> = ({ display }) => {
	if (display === 'Parcelpoint') return <Location locationType={LocationType.ParcelPoint} />;
	if (display === 'Postbox') return <Location locationType={LocationType.PostBox} />;
	return <Location locationType={LocationType.PostOffice} />;
};

export default NearestPostboxOrPostoffice;
